// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zzb[data-v-15f40a28] {\n  display: flex;\n  flex-direction: column;\n}\n.line[data-v-15f40a28] {\n  height: 20px;\n  width: 100%;\n  background: #ccc;\n}", ""]);
// Exports
module.exports = exports;
